import React, { memo } from 'react'

// Libraries
import { Col, Row } from 'react-bootstrap'

// Components
import Buttons from '../Components/Button/Buttons'

// Data
const pricingTable03MonthData = [

    {
        icon: "line-icon-Business-ManWoman",
        title: "Basic",
        subtitle: "",
        price: "",
        // term: "monthly",
        plans: [
            `<strong>Join for Free</strong>`,
            `<strong> Create and Manage Your Professional Business Profile with Ease</strong>`,
            `<strong> Post Unlimited Job Listings Anytime</strong>`,
            `<strong> Verify Candidates at Just $1 Per Profile Whenever Needed</strong> `,
            `<strong> Help Center Resources Instantly</strong> `,
            `<strong> Enjoy all Essential Features</strong> `
        ],
        buttonTitle: "Buy Now",
        buttonLink: "/contact_us",
        // popular: {
        //     isPopular: true
        // }
    },
    {
        icon: "line-icon-Business-Mens",
        title: "Standard",
        subtitle: "",
        price: "",
        // term: "monthly",
        plans: [
            `<strong>$100/month</strong>`,
            `<strong>Verify up to 15,000 Profiles per Year</strong>`,
            `<strong>$1,000 in Advertising Credits</strong>`,
            `<strong>5,000 Credits to Connect with Companies for Instant Back Checks</strong>  `,
            `<strong>Instant Customer Support Access</strong>`,
            `<strong>All Freemium Features Included</strong>`
        ],
        buttonTitle: "Buy Now",
        buttonLink: "/contact_us",
        popular: {
            isPopular: true
        }
    },
    {
        icon: "line-icon-Boy",
        title: "Advanced",
        subtitle: "",
        price: "",
        // term: "monthly",
        plans: [
            `<strong>$500/month</strong>`,
            ` <strong>Verify up to 15,000 Profiles per Year</strong>`,
            `<strong>$1,000 in Advertising Credits</strong>`,
            `<strong>5,000 Credits to Connect with Companies for Instant Back Checks</strong>`,
            `<strong>Instant Customer Support Access</strong>`,
            `<strong>All Freemium Features Included</strong>`
        ],
        buttonTitle: "Buy Now",
        buttonLink: "/contact_uss",

    },
]


const PricingTable01 = (props) => {
    return (
        <Row className={`${props.grid} ${props.className}`}>
            {
                props.data.map((item, i) => {
                    return (
                        <Col key={i} className={`${props.theme}${(item.popular && item.popular.isPopular) ? " popular" : ""} ${props.themeColor} flex text-center justify-center rounded-md`} style={(item.popular && item.popular.color) && {"--popular-bg": item.popular.color}}>
                            <div className="pricing-wrapper">
                                {(item.popular && item.popular.isPopular) && <span className="top-head hidden">Popular</span>}
                                {item.title && <div className="pricing-head font-medium text-xlg uppercase font-serif">{item.title}</div>}
                                {item.subtitle && <div className="pricing-sub-head text-sm uppercase mb-[40px]">{item.subtitle}</div>}
                                {item.price && <h3 className="heading-4 price-wrap mb-[5px] -tracking-[1px]">{item.price}</h3>}
                                {item.term && <div className="text-md">{item.term}</div>}
                                <span className="plans-wrapper block">
                                    <ul className="pl-0 m-0 list-none py-[30px]">
                                        {
                                            item.plans && item.plans.map((item, i) => {
                                                return (
                                                    <li key={i} dangerouslySetInnerHTML={{ __html: item }}></li>
                                                )
                                            })
                                        }
                                    </ul>
                                </span>
                                {
                                    item.buttonLink && (
                                        (item.popular && item.popular.isPopular) ? (
                                            <Buttons ariaLabel="pricing table" to={item.buttonLink} className="btn-explore-yellow bto"  title={item.buttonTitle} />
                                        ) : (
                                            <Buttons ariaLabel="pricing table" to={item.buttonLink} className="btn-explore-white bto"  title={item.buttonTitle} />
                                        )
                                    )
                                }
                            </div>
                        </Col>
                    )
                })
            }
        </Row>

    )
}

PricingTable01.defaultProps = {
    data: pricingTable03MonthData
}

export default memo(PricingTable01)